function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.0844 8.89628C18.6035 10.5148 17.0179 12.3153 17.0179 15.0816C17.0179 15.9172 17.1999 17.3003 17.5897 18.6308H15.4333L11.8741 5.817C11.3281 6.99146 10.5487 7.98311 9.71769 8.89628C8.26261 10.5148 6.65129 12.3153 6.65129 15.0816C6.65129 15.9172 6.83328 17.3003 7.22302 18.6308H5.06659L0 0.362061H2.00018L5.43058 12.9155C5.79368 10.645 7.30114 9.10495 8.62661 7.51314C9.74433 6.18174 10.7573 5.05989 10.7573 3.15418C10.7573 2.31949 10.5495 1.27523 10.2894 0.362061H12.3686L15.7981 12.9155C16.1621 10.645 17.6687 9.10495 18.9942 7.51314C20.111 6.18174 21.0725 4.7986 21.0725 2.89379C21.0725 2.0582 20.9162 1.27523 20.657 0.362061H22.5018C22.7353 0.936359 22.9173 1.66672 22.9173 2.68512C22.9164 5.39876 21.5394 7.30447 20.0844 8.89628Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.0015 0.362061V18.6308H26.8193V0.362061H29.0015Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.7903 0.362061L45.4426 14.1158C45.4426 14.1158 46.0641 15.1601 46.2221 15.5515V0.362061H48.3004V18.6308H45.9868L37.3363 4.87708C37.3363 4.87708 36.7148 3.83282 36.5568 3.44133V18.6308H34.4785V0.362061H36.7903Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.1349 0.362061L64.7873 14.1158C64.7873 14.1158 65.4087 15.1601 65.5668 15.5515V0.362061H67.6495V18.6308H65.3324L56.6809 4.87708C56.6809 4.87708 56.0595 3.83282 55.9015 3.44133V18.6308H53.8223V0.362061H56.1349Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.0026 19C76.1198 19 72.2207 15.1895 72.2207 9.5C72.2207 3.81052 76.1181 0 81.0026 0C85.8872 0 89.7846 3.81052 89.7846 9.5C89.7846 15.1895 85.8872 19 81.0026 19ZM87.55 9.5C87.55 4.95912 84.7438 1.93157 81.0026 1.93157C77.2615 1.93157 74.4553 4.95912 74.4553 9.5C74.4553 14.0409 77.2615 17.0684 81.0026 17.0684C84.7438 17.0684 87.55 14.0382 87.55 9.49643V9.5Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.0291 18.6308L91.9102 0.362061H94.0666L97.7562 14.1158L98.2001 16.0215C98.3297 15.3687 98.644 14.0899 98.644 14.0899L102.2 0.362061H104.538L108.097 14.0899C108.097 14.0899 108.409 15.3687 108.541 16.0215L108.985 14.1158L112.67 0.362061H114.827L109.708 18.6308H107.448L103.364 3.0766L99.285 18.6308H97.0291Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 115,
    height: 19,
    viewBox: "0 0 115 19"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/logo.1a788cd5.svg";
export { SvgComponent as ReactComponent };